import CryptoJS from 'crypto-js';

export const encrypt = (text: any, clave: any)=>
{
    return CryptoJS.AES.encrypt(text, clave).toString();
}
export const decrypt = (text: any, clave: any)=>
{
    return CryptoJS.AES.decrypt(text, clave).toString(CryptoJS.enc.Utf8);
}